import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import DashboardSidebar from './DashboardSidebar/DashboardSidebar';
import { DashboardLayoutProps, DashboardPages } from './DashboardLayout.types';
import '../../../styles/Dashboard.css';
import Loading from '../Loading/Loading';

export default ({ children, isLoading, ...props }: DashboardLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentView, setCurrentView] = useState<DashboardPages>(DashboardPages.Home);

  useEffect(() => {
    const [, namespace, repository] = location.pathname.split('/');
    const pathExists = Boolean(Object.values(DashboardPages).find((page) => page === repository));
    if (pathExists) {
      setCurrentView(repository as DashboardPages);
    } else if (namespace === 'dashboard') {
      setCurrentView(DashboardPages.Home);
    } else {
      navigate('/dashboard');
    }
  });

  return (
    <div className="dashboard">
      <DashboardSidebar {...{ currentView }} />
      <div className="dashboard__main" {...props}>
        {isLoading ? <Loading /> : children}
      </div>
    </div>
  );
};
